import { render, staticRenderFns } from "./ReportingNumbers.vue?vue&type=template&id=5cc71cbc&scoped=true"
import script from "./ReportingNumbers.vue?vue&type=script&lang=js"
export * from "./ReportingNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc71cbc",
  null
  
)

export default component.exports